import { render, staticRenderFns } from "./ScrollRevealer.vue?vue&type=template&id=15900fe4&scoped=true&"
import script from "./ScrollRevealer.vue?vue&type=script&lang=js&"
export * from "./ScrollRevealer.vue?vue&type=script&lang=js&"
import style0 from "./ScrollRevealer.vue?vue&type=style&index=0&id=15900fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15900fe4",
  null
  
)

export default component.exports